import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { cookie } from '@ifeng-fe/ui_base';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '../../../../utils/rel';

class CityNav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        areaTitle: '',
        areaUrl: '',
    };

    componentDidMount() {}

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.nav_box}>
                <div className={styles.nav_list}>
                    <ul className={styles.sub_nav}>
                        {content.map((item, index) => (
                            <li key={index}>
                                <a href={item.url} target="_blank" rel={rel} title={item.title}>
                                    {item.title}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
}

export default errorBoundary(CityNav);
